/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
/* eslint-disable no-use-before-define */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import arClient from '../util/api_client';
import { isApiSuccess } from '../constants/platformStatusCodes';
import store from '../store';
import { userFlowTrackEvent } from '../components/Global/userFlow';
import {
  setAdvertiserIDList,
  setAdvertiserSparkLoading,
} from '../components/Campaigns/Campaigns.slice';
import {
  GET_WORD_LIST,
  DELETE_WORD,
  ADD_WORD,
  CHECK_HUBSPOT,
  CHECK_MAILCHIMP,
  HUBSPOT_AUTH_LINK,
  ADWORDS_AUTH_LINKS,
  HUBSPOT_CONNECT,
  HUBSPOT_DISCONNECT,
  MAILCHIMP_CONNECT,
  MAILCHIMP_DISCONNECT,
  MAILCHIMP_AUTH_LINK,
  GET_CONTENT_LIST,
  GET_CONTENT_URL,
  GET_GA_PROFILES,
  UPDATE_GA_PROFILE,
  ADD_GA_PROFILE,
  CHECK_WORDPRESS,
  ADD_NEW_ARTICLE_URL,
  HUBSPOT_BLOG_INSTACES_LIST,
  MARKETO_CONNECT,
  MARKETO_DISCONNECT,
  IS_MARKETO_CONNECTED,
  MARKETO_UPDATE_CONFIGURATION,
  CHECK_ADWORDS_CONNECTED,
  ADWORDS_CONNECT,
  ADWORDS_DEFAULT_ACCOUNT,
  ADWORDS_ACTIVATE_CONNECTIONID,
  ADWORDS_DISCONNECT_CONNECTIONID,
  ADWORDS_DISCONNECT,
  LOG_EVENT,
  SEARCHCONSOLE_AUTH_LINKS,
  SEARCHCONSOLE_CONNECT,
  GOOGLE_ANALYTICS_AUTH_LINKS,
  GOOGLE_ANALYTICS_CONNECT,
  GET_SEARCH_CONSOLE_PROPERTIES_LIST,
  SET_PROPERTY_TO_SOURCE,
  CHARGIFY_SUBSCRIPTION_VALIDATION,
  WORDPRESS_DISCONNECT_BY_SOURCE_ID,
  MARKETO_GET_FOLDERS,
  GET_SUB_ACCOUNTS,
  ADD_SUB_ACCOUNTS,
  REMOVE_SUB_ACCOUNTS,
  UPDATE_SUB_ACCOUNT,
} from '../constants/apiUrls';

const initialState = {
  previousTab: '',
  previousPath: '',
  previousData: {},
  initialPrevious: false,
  accountInfo: {},
  accountQuota: {},
  quotaExceededInfo: {},
  wordList: {
    dictionary: {},
    compliance: {},
    ignore: {},
  },
  wordsToAdd: [],
  fetchingHubspotConnection: false,
  fetchingMailchimpConnection: false,
  fetchingMarketoConnection: false,
  fetchingWordpressConnection: false,
  fetchingAdwordsConnection: false,
  wordpressConnection: {
    connected: false,
    data: {},
  },
  hubspotConnection: {
    connected: false,
    data: {},
  },
  hubspotBlogs: [],
  mailchimpConnection: {
    connected: false,
    data: {},
  },
  marketoConnection: {
    connected: false,
    data: {},
  },
  marketoFoldersFetching: false,
  marketoFolders: {
    treeData: [],
    defaultCheckedKeys: [],
  },
  adwordsConnection: {
    connected: false,
    data: {},
  },
  adwordsConnections: [],
  adwordsDefault: '',
  activeConnectionId: '',
  contentSources: [],
  creatingContentSource: false,
  creatingContentSourceSuccess: '',
  creatingContentSourceError: '',
  GaProfiles: {},
  clientCustomerAccounts: [],
  addingNewArticle: false,
  fetchingSubAccounts: false,
  subAccountsData: {},
  loadingSocialMediaConnections: false,
  socialMediaConnections: {},
};

// Async thunks
export const fetchAccountQuota = createAsyncThunk(
  'settings/fetchAccountQuota',
  async () => {
    const resp = await arClient.doApiCallAsync('/usage/data', {});
    return resp.data;
  }
);

export const fetchSubAccounts = createAsyncThunk(
  'settings/fetchSubAccounts',
  async () => {
    const resp = await arClient.doApiCallAsync(GET_SUB_ACCOUNTS, {});
    return resp;
  }
);

export const addSubAccount = createAsyncThunk(
  'settings/addSubAccount',
  async ({ email, password }) => {
    const resp = await arClient.doApiCallAsync(ADD_SUB_ACCOUNTS, {
      emailAddress: email,
      password,
    });
    return resp;
  }
);

export const updateSubAccount = createAsyncThunk(
  'settings/updateSubAccount',
  async subAccountData => {
    const resp = await arClient.doApiCallAsync(
      UPDATE_SUB_ACCOUNT,
      subAccountData
    );
    return resp;
  }
);

export const removeSubAccount = createAsyncThunk(
  'settings/removeSubAccount',
  async ({ subAccountId }) => {
    const resp = await arClient.doApiCallAsync(REMOVE_SUB_ACCOUNTS, {
      subAccountId,
    });
    return resp;
  }
);

export const fetchWords = createAsyncThunk(
  'settings/fetchWords',
  async ({ list }) => {
    const url = GET_WORD_LIST.replace(':list', list);
    const resp = await arClient.doApiCallAsync(url, {});
    return { list, words: resp.words };
  }
);

export const deleteWord = createAsyncThunk(
  'settings/deleteWord',
  async ({ word, letter, list }, { dispatch }) => {
    dispatch(settingsSlice.actions.spliceWordFromList({ word, letter, list }));
    const url = DELETE_WORD.replace(':list', list);
    await arClient.doApiCallAsync(url, { word });
    return { word, letter, list };
  }
);

export const deleteWordWithoutWordListListModify = createAsyncThunk(
  'settings/deleteWordWithoutWordListListModify',
  async ({ word, list }) => {
    const url = DELETE_WORD.replace(':list', list);
    await arClient.doApiCallAsync(url, { word });
    return { word, list };
  }
);

export const addWord = createAsyncThunk(
  'settings/addWord',
  async ({ word, list }) => {
    const url = ADD_WORD.replace(':list', list);
    await arClient.doApiCallAsync(url, { word });
    return { word, list };
  }
);

export const getHubspotAuthLink = createAsyncThunk(
  'settings/getHubspotAuthLink',
  async ({ redirectURI }, { dispatch }) => {
    dispatch(settingsSlice.actions.requestHubspotCheck());
    const resp = await arClient.doApiCallAsync(HUBSPOT_AUTH_LINK, {
      redirectURI,
    });
    return resp;
  }
);

export const getAdwordsAuthLink = createAsyncThunk(
  'settings/getAdwordsAuthLink',
  async ({ redirectURI }) => {
    const resp = await arClient.doApiCallAsync(ADWORDS_AUTH_LINKS, {
      redirectURI,
    });
    return resp;
  }
);

export const getSearchConsoleAuthLink = createAsyncThunk(
  'settings/getSearchConsoleAuthLink',
  async ({ redirectURI }) => {
    const resp = await arClient.doApiCallAsync(SEARCHCONSOLE_AUTH_LINKS, {
      redirectURI,
    });
    return resp;
  }
);

export const getGoogleAnalyticsAuthLink = createAsyncThunk(
  'settings/getGoogleAnalyticsAuthLink',
  async ({ redirectURI }) => {
    const resp = await arClient.doApiCallAsync(GOOGLE_ANALYTICS_AUTH_LINKS, {
      redirectURI,
    });
    return resp;
  }
);

export const setPropertyToSource = createAsyncThunk(
  'settings/setPropertyToSource',
  async ({ url, sourceId }) => {
    const resp = await arClient.doApiCallAsync(SET_PROPERTY_TO_SOURCE, {
      url,
      sourceId,
    });
    return resp;
  }
);

export const connectAdWords = createAsyncThunk(
  'settings/connectAdWords',
  async ({ redirectURI, tokenCode }) => {
    const resp = await arClient.doApiCallAsync(ADWORDS_CONNECT, {
      redirectURI,
      tokenCode,
    });
    return resp;
  }
);

export const checkForHubspot = createAsyncThunk(
  'settings/checkForHubspot',
  async (_, { dispatch }) => {
    dispatch(settingsSlice.actions.requestHubspotCheck());
    const resp = await arClient.doApiCallAsync(CHECK_HUBSPOT, {});
    return resp;
  }
);

export const connectHubspot = createAsyncThunk(
  'settings/connectHubspot',
  async ({ redirectURI, tokenCode }, { dispatch }) => {
    dispatch(settingsSlice.actions.requestHubspotCheck());
    const resp = await arClient.doApiCallAsync(HUBSPOT_CONNECT, {
      redirectURI,
      tokenCode,
    });
    return resp;
  }
);

export const connectAdwords = createAsyncThunk(
  'settings/connectAdwords',
  async ({ redirectURI, tokenCode }, { dispatch }) => {
    dispatch(settingsSlice.actions.requestHubspotCheck());
    const resp = await arClient.doApiCallAsync(ADWORDS_CONNECT, {
      redirectURI,
      tokenCode,
    });
    return resp;
  }
);

export const connectSearchConsole = createAsyncThunk(
  'settings/connectSearchConsole',
  async ({ redirectURI, tokenCode }) => {
    const resp = await arClient.doApiCallAsync(SEARCHCONSOLE_CONNECT, {
      redirectURI,
      tokenCode,
    });
    return resp;
  }
);

export const connectGoogleAnalytics = createAsyncThunk(
  'settings/connectGoogleAnalytics',
  async ({ redirectURI, tokenCode }) => {
    const resp = await arClient.doApiCallAsync(GOOGLE_ANALYTICS_CONNECT, {
      redirectURI,
      tokenCode,
    });
    return resp;
  }
);

export const connectMailChimp = createAsyncThunk(
  'settings/connectMailChimp',
  async ({ redirectURI, tokenCode }, { dispatch }) => {
    dispatch(settingsSlice.actions.requestHubspotCheck());
    const resp = await arClient.doApiCallAsync(MAILCHIMP_CONNECT, {
      redirectURI: JSON.stringify(redirectURI),
      tokenCode: tokenCode.trim(),
    });
    return resp;
  }
);

export const disconnectHubspot = createAsyncThunk(
  'settings/disconnectHubspot',
  async (_, { dispatch }) => {
    dispatch(settingsSlice.actions.requestHubspotCheck());
    const resp = await arClient.doApiCallAsync(HUBSPOT_DISCONNECT, {});
    return resp;
  }
);

export const disconnectMailChimp = createAsyncThunk(
  'settings/disconnectMailChimp',
  async (_, { dispatch }) => {
    dispatch(settingsSlice.actions.requestMailChimpCheck());
    const resp = await arClient.doApiCallAsync(MAILCHIMP_DISCONNECT, {});
    return resp;
  }
);

export const disconnectWordPress = createAsyncThunk(
  'settings/disconnectWordPress',
  async ({ sourceId }, { dispatch }) => {
    dispatch(settingsSlice.actions.requestWordPressCheck());
    const resp = await arClient.doApiCallAsync(
      WORDPRESS_DISCONNECT_BY_SOURCE_ID,
      { sourceId }
    );
    return resp;
  }
);

export const checkForMailChimp = createAsyncThunk(
  'settings/checkForMailChimp',
  async (_, { dispatch }) => {
    dispatch(settingsSlice.actions.requestMailChimpCheck());
    const resp = await arClient.doApiCallAsync(CHECK_MAILCHIMP, {});
    return resp;
  }
);

export const getMailChimpAuthLink = createAsyncThunk(
  'settings/getMailChimpAuthLink',
  async ({ redirectURI }, { dispatch }) => {
    dispatch(settingsSlice.actions.requestMailChimpCheck());
    const resp = await arClient.doApiCallAsync(MAILCHIMP_AUTH_LINK, {
      redirectURI,
    });
    return resp;
  }
);

export const checkForWordPress = createAsyncThunk(
  'settings/checkForWordPress',
  async (_, { dispatch }) => {
    dispatch(settingsSlice.actions.requestWordPressCheck());
    const resp = await arClient.doApiCallAsync(CHECK_WORDPRESS, {});
    return resp;
  }
);

export const getContentSourceList = createAsyncThunk(
  'settings/getContentSourceList',
  async () => {
    const resp = await arClient.doApiCallAsync(GET_CONTENT_LIST, {});
    return resp;
  }
);

export const getSearchConsolePropertiesList = createAsyncThunk(
  'settings/getSearchConsolePropertiesList',
  async () => {
    const resp = await arClient.doApiCallAsync(
      GET_SEARCH_CONSOLE_PROPERTIES_LIST,
      {}
    );
    return resp;
  }
);

export const addNewArticleToSource = createAsyncThunk(
  'settings/addNewArticleToSource',
  async ({ url, sourceId }, { dispatch }) => {
    dispatch(settingsSlice.actions.requestAddArticle());
    const resp = await arClient.doApiCallAsync(ADD_NEW_ARTICLE_URL, {
      url,
      sourceId,
    });
    return resp;
  }
);

export const fetchGaProfiles = createAsyncThunk(
  'settings/fetchGaProfiles',
  async () => {
    const resp = await arClient.doApiCallAsync(GET_GA_PROFILES, {});
    return resp;
  }
);

export const checkMarketo = createAsyncThunk(
  'settings/checkMarketo',
  async (_, { dispatch }) => {
    dispatch(settingsSlice.actions.requestMarketoCheck());
    const resp = await arClient.doApiCallAsync(IS_MARKETO_CONNECTED, {});
    return resp;
  }
);

export const checkAdwords = createAsyncThunk(
  'settings/checkAdwords',
  async (_, { dispatch }) => {
    dispatch(settingsSlice.actions.requestAdwordsCheck());
    const resp = await arClient.doApiCallAsync(CHECK_ADWORDS_CONNECTED, {});
    return resp;
  }
);

export const getMarketoFolders = createAsyncThunk(
  'settings/getMarketoFolders',
  async (_, { dispatch }) => {
    dispatch(settingsSlice.actions.marketoFoldersFetching(true));
    const resp = await arClient.doApiCallAsync(MARKETO_GET_FOLDERS, {});
    dispatch(settingsSlice.actions.marketoFoldersFetching(false));
    return resp;
  }
);

export const connectMarketo = createAsyncThunk(
  'settings/connectMarketo',
  async ({ endpointURL, clientId, clientSecret }, { dispatch }) => {
    dispatch(settingsSlice.actions.requestMarketoCheck());
    const resp = await arClient.doApiCallAsync(MARKETO_CONNECT, {
      apiURI: endpointURL,
      clientId,
      clientSecret,
    });
    const jsonResponse = resp.responseJSON || resp;
    return jsonResponse;
  }
);

export const updateConfigurationMarketo = createAsyncThunk(
  'settings/updateConfigurationMarketo',
  async ({
    marketoConfigDailyApiCall,
    marketoConfigDailyFileSize,
    marketoConfigMinDate,
    marketoSelectedFolderKeys,
  }) => {
    const resp = await arClient.doApiCallAsync(MARKETO_UPDATE_CONFIGURATION, {
      marketoConfigDailyApiCall,
      marketoConfigDailyFileSize,
      marketoConfigMinDate,
      marketoSelectedFolderKeys,
    });
    return resp;
  }
);

export const disconnectMarketo = createAsyncThunk(
  'settings/disconnectMarketo',
  async (_, { dispatch }) => {
    dispatch(settingsSlice.actions.requestMarketoCheck());
    const resp = await arClient.doApiCallAsync(MARKETO_DISCONNECT, {});
    return resp;
  }
);

export const updateGaProfile = createAsyncThunk(
  'settings/updateGaProfile',
  async ({ gaId, sourceId }) => {
    const resp = await arClient.doApiCallAsync(UPDATE_GA_PROFILE, {
      analyticsId: gaId,
      sourceId,
    });
    return resp;
  }
);

export const addSocialProfile = createAsyncThunk(
  'settings/addSocialProfile',
  async ({ sourceId, socialNetworkCode }) => {
    const resp = await arClient.doApiCallAsync(ADD_GA_PROFILE, {
      sourceId,
      networkCode: socialNetworkCode.toUpperCase(),
    });
    return resp;
  }
);

export const addSeoProfile = createAsyncThunk(
  'settings/addSeoProfile',
  async ({ sourceId, socialNetworkCode }) => {
    const resp = await arClient.doApiCallAsync(ADD_GA_PROFILE, {
      sourceId,
      networkCode: socialNetworkCode.toUpperCase(),
    });
    return resp;
  }
);

export const fetchContentByUrl = createAsyncThunk(
  'settings/fetchContentByUrl',
  async ({ url }, { dispatch }) => {
    dispatch(settingsSlice.actions.requestContentByUrl());
    const resp = await arClient.doApiCallAsync(GET_CONTENT_URL, {
      url: JSON.stringify(url),
      isForced: 1,
      doAddNewSource: 1,
    });
    return resp;
  }
);

export const saveDefaultAccount = createAsyncThunk(
  'settings/saveDefaultAccount',
  async ({ clientCustomerId, connectionId }, { dispatch }) => {
    dispatch(settingsSlice.actions.fetchingAdData());
    const resp = await arClient.doApiCallAsync(ADWORDS_DEFAULT_ACCOUNT, {
      clientCustomerId,
      connectionId,
    });
    dispatch(settingsSlice.actions.doneLoadingAdData());
    return resp;
  }
);

export const setPrimaryAccount = createAsyncThunk(
  'settings/setPrimaryAccount',
  async ({ connectionId }, { dispatch }) => {
    dispatch(settingsSlice.actions.fetchingAdData());
    const resp = await arClient.doApiCallAsync(ADWORDS_ACTIVATE_CONNECTIONID, {
      connectionId,
    });
    dispatch(settingsSlice.actions.doneLoadingAdData());
    return resp;
  }
);

export const disconnectConnection = createAsyncThunk(
  'settings/disconnectConnection',
  async ({ connectionId }, { dispatch }) => {
    dispatch(settingsSlice.actions.fetchingAdData());
    const resp = await arClient.doApiCallAsync(
      ADWORDS_DISCONNECT_CONNECTIONID,
      { connectionId }
    );
    dispatch(settingsSlice.actions.doneLoadingAdData());
    return resp;
  }
);

export const disconnectAdwords = createAsyncThunk(
  'settings/disconnectAdwords',
  async (_, { dispatch }) => {
    dispatch(settingsSlice.actions.fetchingAdData());
    const resp = await arClient.doApiCallAsync(ADWORDS_DISCONNECT, {});
    dispatch(settingsSlice.actions.doneLoadingAdData());
    return resp;
  }
);

export const fetchSocialMediaConnections = createAsyncThunk(
  'settings/fetchSocialMediaConnections',
  async ({ campaignId }, { dispatch }) => {
    const SOCIAL_MEDIA_TYPE = {
      Facebook: 'Facebook',
      Instagram: 'Instagram',
      TikTok: 'TikTok',
      YouTube: 'YouTube',
    };
    const socialTypeArr = Object.values(SOCIAL_MEDIA_TYPE);
    const result = {};

    dispatch(settingsSlice.actions.updateSocialMediaConnLoadingStatus(true));

    const getConnectionsBySocialType = async (cId, socialType) => {
      return new Promise((resolve, reject) => {
        arClient.doApiCall(
          '/adverity/connections-list-by-social',
          { socialType, campaignId: cId },
          resp => {
            if (isApiSuccess(resp)) {
              resolve(resp.data);
            } else {
              reject(new Error('Failed to fetch social media connections'));
            }
          }
        );
      });
    };

    const resps = await Promise.allSettled(
      socialTypeArr.map(socialType =>
        getConnectionsBySocialType(campaignId, socialType)
      )
    );

    resps.forEach(({ status, value: connections }, idx) => {
      const socialType = socialTypeArr[idx];
      const activeAccounts = [];
      if (status === 'fulfilled') {
        connections.forEach(({ authStatus, billings, accountConnectionId }) => {
          if (authStatus === 'inactive') {
            return;
          }
          billings.forEach(billing => {
            if (billing.status === 'Active') {
              activeAccounts.push({
                name: billing.name,
                billingObjectId: billing.id,
                accountConnectionId,
              });
            }
          });
        });
      }
      result[socialType] = {
        activeAccounts,
        connected: activeAccounts.length > 0,
      };
    });

    dispatch(settingsSlice.actions.updateSocialMediaConnLoadingStatus(false));
    dispatch(settingsSlice.actions.updateSocialMediaConn(result));
    return result;
  }
);

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    resetSettings: () => initialState,
    storePreviousPage: (state, action) => {
      const { path, tab, profileData } = action.payload;
      state.previousTab = tab;
      state.previousPath = path;
      state.previousProfileData = profileData;
    },
    getAccountInfo: (state, action) => {
      state.accountInfo = action.payload;
    },
    getAccountQuota: (state, action) => {
      state.accountQuota = action.payload;
    },
    clearQuotaExceededInfo: state => {
      state.quotaExceededInfo = {};
    },
    toggleFetchingSubAccount: state => {
      state.fetchingSubAccounts = !state.fetchingSubAccounts;
    },
    subAccountData: (state, action) => {
      state.subAccountsData = action.payload;
    },
    updateDictionaryWordList: (state, action) => {
      state.wordList.dictionary = action.payload;
    },
    updateIgnoreWordList: (state, action) => {
      state.wordList.ignore = action.payload;
    },
    updateComplianceWordList: (state, action) => {
      state.wordList.compliance = action.payload;
    },
    spliceWordFromList: (state, action) => {
      const { word, letter, list } = action.payload;
      const index = state.wordList[list][letter].indexOf(word);
      if (index !== -1) {
        state.wordList[list][letter].splice(index, 1);
      }
    },
    updateWordsToAdd: (state, action) => {
      state.wordsToAdd = action.payload;
    },
    requestMailChimpCheck: state => {
      state.fetchingMailchimpConnection = true;
    },
    requestMarketoCheck: state => {
      state.fetchingMarketoConnection = true;
    },
    marketoFetFolders: (state, action) => {
      state.marketoFolders = action.payload.data;
    },
    marketoFoldersFetching: (state, action) => {
      state.marketoFoldersFetching = action.payload;
    },
    marketoCheckSuccess: (state, action) => {
      state.fetchingMarketoConnection = false;
      state.marketoConnection = {
        connected: true,
        data: action.payload.data,
      };
    },
    marketoCheckFailed: state => {
      state.fetchingMarketoConnection = false;
      state.marketoConnection = {
        connected: false,
        data: false,
      };
    },
    requestAdwordsCheck: state => {
      state.fetchingAdwordsConnection = true;
    },
    adwordsCheckSuccess: (state, action) => {
      const clientCustomerList = [];
      Object.keys(action.payload.data).forEach(key => {
        const results = {
          id: key,
          name: action.payload.data[key],
        };
        clientCustomerList.push(results);
      });

      state.fetchingAdwordsConnection = false;
      state.adwordsDefault = action.payload.defaultCustomerId;
      state.adwordsConnections = action.payload.connections;
      state.activeConnectionId = action.payload.activeConnectionId;
      state.clientCustomerAccounts = clientCustomerList;
      state.adwordsConnection = {
        connected: true,
        data: action.payload.data,
      };
    },
    adwordsCheckFailed: state => {
      state.fetchingAdwordsConnection = false;
      state.adwordsConnection = {
        connected: false,
        data: false,
      };
    },
    mailChimpCheckSuccess: (state, action) => {
      state.fetchingMailchimpConnection = false;
      state.mailchimpConnection = {
        connected: true,
        data: action.payload.data,
      };
    },
    mailChimpCheckFailed: state => {
      state.fetchingMailchimpConnection = false;
      state.mailchimpConnection = {
        connected: false,
        data: false,
      };
    },
    requestHubspotCheck: state => {
      state.fetchingHubspotConnection = true;
    },
    hubspotCheckSuccess: (state, action) => {
      state.fetchingHubspotConnection = false;
      state.hubspotConnection = {
        connected: true,
        data: action.payload.data,
      };
    },
    hubspotCheckFailed: state => {
      state.fetchingHubspotConnection = false;
      state.hubspotConnection = {
        connected: false,
        data: {},
      };
    },
    requestContentByUrl: state => {
      state.creatingContentSource = true;
    },
    createdContentByUrl: (state, action) => {
      state.creatingContentSource = false;
      state.creatingContentSourceSuccess = action.payload;
    },
    requestWordPressCheck: state => {
      state.fetchingWordpressConnection = true;
    },
    wordPressCheckSuccess: (state, action) => {
      state.fetchingWordpressConnection = false;
      state.wordpressConnection = {
        connected: action.payload.data.length > 0,
        data: action.payload.data,
      };
    },
    wordPressCheckFailed: state => {
      state.fetchingWordpressConnection = false;
      state.wordpressConnection = {
        connected: false,
        data: {},
      };
    },
    failedContentByUrl: (state, action) => {
      state.creatingContentSource = false;
      state.creatingContentSourceError = action.payload.error;
    },
    getContentSources: (state, action) => {
      state.contentSources = action.payload.sources;
    },
    getSearchConsoleProperties: (state, action) => {
      state.searchConsoleProperties = action.payload.data
        ? action.payload.data
        : null;
    },
    fetchGaProfilesData: (state, action) => {
      state.GaProfiles = action.payload.data;
    },
    requestAddArticle: state => {
      state.addingNewArticle = true;
    },
    addArticleSuccess: state => {
      state.addingNewArticle = false;
    },
    addArticleFailed: state => {
      state.addingNewArticle = true;
    },
    updateHubspotBlogList: (state, action) => {
      state.hubspotBlogs = action.payload;
    },
    fetchingAdData: state => {
      state.fetchingAdwordsConnection = true;
    },
    doneLoadingAdData: state => {
      state.fetchingAdwordsConnection = false;
    },
    updateSocialMediaConnLoadingStatus: (state, action) => {
      state.loadingSocialMediaConnections = action.payload;
    },
    updateSocialMediaConn: (state, action) => {
      state.socialMediaConnections = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAccountQuota.fulfilled, (state, action) => {
        state.accountQuota = action.payload;
      })
      .addCase(fetchSubAccounts.pending, state => {
        state.fetchingSubAccounts = true;
      })
      .addCase(fetchSubAccounts.fulfilled, (state, action) => {
        state.fetchingSubAccounts = false;
        if (isApiSuccess(action.payload)) {
          state.subAccountsData = action.payload.data;
        } else {
          state.subAccountsData = {};
        }
      })
      .addCase(fetchSubAccounts.rejected, state => {
        state.fetchingSubAccounts = false;
        state.subAccountsData = {};
      })
      .addCase(fetchWords.fulfilled, (state, action) => {
        const { list, words } = action.payload;
        switch (list) {
          case 'dictionary':
            state.wordList.dictionary = words;
            break;
          case 'ignore':
            state.wordList.ignore = words;
            break;
          case 'compliance':
            state.wordList.compliance = words;
            break;
          default:
            break;
        }
      })
      .addCase(checkForHubspot.fulfilled, (state, action) => {
        state.fetchingHubspotConnection = false;
        state.hubspotConnection = {
          connected: true,
          data: action.payload.data,
        };
      })
      .addCase(checkForHubspot.rejected, state => {
        state.fetchingHubspotConnection = false;
        state.hubspotConnection = {
          connected: false,
          data: {},
        };
      })
      .addCase(connectHubspot.fulfilled, (state, action) => {
        state.fetchingHubspotConnection = false;
        state.hubspotConnection = {
          connected: true,
          data: action.payload.data,
        };
      })
      .addCase(connectHubspot.rejected, state => {
        state.fetchingHubspotConnection = false;
        state.hubspotConnection = {
          connected: false,
          data: {},
        };
      })
      .addCase(connectAdwords.fulfilled, (state, action) => {
        state.fetchingHubspotConnection = false;
        state.hubspotConnection = {
          connected: true,
          data: action.payload.data,
        };
      })
      .addCase(connectAdwords.rejected, state => {
        state.fetchingHubspotConnection = false;
        state.hubspotConnection = {
          connected: false,
          data: {},
        };
      })
      .addCase(connectMailChimp.fulfilled, (state, action) => {
        state.fetchingMailchimpConnection = false;
        state.mailchimpConnection = {
          connected: true,
          data: action.payload.data,
        };
      })
      .addCase(connectMailChimp.rejected, state => {
        state.fetchingMailchimpConnection = false;
        state.mailchimpConnection = {
          connected: false,
          data: {},
        };
      })
      .addCase(disconnectHubspot.fulfilled, state => {
        state.fetchingHubspotConnection = false;
        state.hubspotConnection = {
          connected: false,
          data: false,
        };
      })
      .addCase(disconnectHubspot.rejected, state => {
        state.fetchingHubspotConnection = false;
        state.hubspotConnection = {
          connected: true,
          data: {},
        };
      })
      .addCase(disconnectMailChimp.fulfilled, state => {
        state.fetchingMailchimpConnection = false;
        state.mailchimpConnection = {
          connected: false,
          data: false,
        };
      })
      .addCase(disconnectMailChimp.rejected, state => {
        state.fetchingMailchimpConnection = false;
        state.mailchimpConnection = {
          connected: true,
          data: {},
        };
      })
      .addCase(disconnectWordPress.fulfilled, state => {
        state.fetchingWordpressConnection = false;
        state.wordpressConnection = {
          connected: false,
          data: {},
        };
      })
      .addCase(disconnectWordPress.rejected, state => {
        state.fetchingWordpressConnection = false;
      })
      .addCase(checkForMailChimp.fulfilled, (state, action) => {
        state.fetchingMailchimpConnection = false;
        state.mailchimpConnection = {
          connected: true,
          data: action.payload.data,
        };
      })
      .addCase(checkForMailChimp.rejected, state => {
        state.fetchingMailchimpConnection = false;
        state.mailchimpConnection = {
          connected: false,
          data: false,
        };
      })
      .addCase(checkForWordPress.fulfilled, (state, action) => {
        state.fetchingWordpressConnection = false;
        state.wordpressConnection = {
          connected: action.payload.data.length > 0,
          data: action.payload.data,
        };
      })
      .addCase(checkForWordPress.rejected, state => {
        state.fetchingWordpressConnection = false;
        state.wordpressConnection = {
          connected: false,
          data: {},
        };
      })
      .addCase(getContentSourceList.fulfilled, (state, action) => {
        state.contentSources = action.payload.sources;
      })
      .addCase(getSearchConsolePropertiesList.fulfilled, (state, action) => {
        state.searchConsoleProperties = action.payload.data
          ? action.payload.data
          : null;
      })
      .addCase(addNewArticleToSource.fulfilled, state => {
        state.addingNewArticle = false;
      })
      .addCase(addNewArticleToSource.rejected, state => {
        state.addingNewArticle = true;
      })
      .addCase(fetchGaProfiles.fulfilled, (state, action) => {
        state.GaProfiles = action.payload.data;
      })
      .addCase(checkMarketo.fulfilled, (state, action) => {
        state.fetchingMarketoConnection = false;
        if (action.payload.data) {
          state.marketoConnection = {
            connected: true,
            data: action.payload.data,
          };
        } else {
          state.marketoConnection = {
            connected: false,
            data: false,
          };
        }
      })
      .addCase(checkMarketo.rejected, state => {
        state.fetchingMarketoConnection = false;
        state.marketoConnection = {
          connected: false,
          data: false,
        };
      })
      .addCase(checkAdwords.fulfilled, (state, action) => {
        const clientCustomerList = [];
        if (action.payload.data) {
          Object.keys(action.payload.data).forEach(key => {
            const results = {
              id: key,
              name: action.payload.data[key],
            };
            clientCustomerList.push(results);
          });
        }

        state.fetchingAdwordsConnection = false;
        state.adwordsDefault = action.payload.defaultCustomerId;
        state.adwordsConnections = action.payload.connections;
        state.activeConnectionId = action.payload.activeConnectionId;
        state.clientCustomerAccounts = clientCustomerList;
        state.adwordsConnection = {
          connected: action.payload.data ? true : false,
          data: action.payload.data || false,
        };
      })
      .addCase(checkAdwords.rejected, state => {
        state.fetchingAdwordsConnection = false;
        state.adwordsConnection = {
          connected: false,
          data: false,
        };
      })
      .addCase(getMarketoFolders.fulfilled, (state, action) => {
        state.marketoFolders = action.payload.data;
      })
      .addCase(connectMarketo.fulfilled, (state, action) => {
        state.fetchingMarketoConnection = false;
        state.marketoConnection = {
          connected: true,
          data: action.payload.data,
        };
      })
      .addCase(connectMarketo.rejected, (state, action) => {
        state.fetchingMarketoConnection = false;
        state.marketoConnection = {
          connected: false,
          data: action.payload || false,
        };
      })
      .addCase(disconnectMarketo.fulfilled, state => {
        state.fetchingMarketoConnection = false;
        state.marketoConnection = {
          connected: false,
          data: false,
        };
      })
      .addCase(disconnectMarketo.rejected, state => {
        state.fetchingMarketoConnection = false;
        state.marketoConnection = {
          connected: true,
          data: {},
        };
      })
      .addCase(fetchContentByUrl.fulfilled, (state, action) => {
        state.creatingContentSource = false;
        state.creatingContentSourceSuccess = action.payload;
      })
      .addCase(fetchContentByUrl.rejected, (state, action) => {
        state.creatingContentSource = false;
        state.creatingContentSourceError =
          action.payload?.error || 'Failed to fetch content';
      });
  },
});

// Special thunks that need callbacks (not createAsyncThunk)
export function fetchHubspotBlogList() {
  return dispatch => {
    arClient.doApiCall(HUBSPOT_BLOG_INSTACES_LIST, {}, resp => {
      if (isApiSuccess(resp)) {
        dispatch(
          settingsSlice.actions.updateHubspotBlogList(resp.data.objects)
        );
      }
    });
  };
}

export function verifyChargifyPaymentCallback(chargifySubscriptionId) {
  return () =>
    new Promise((resolve, reject) => {
      arClient.doApiCall(
        CHARGIFY_SUBSCRIPTION_VALIDATION,
        { chargifySubscriptionId },
        resp => {
          if (isApiSuccess(resp)) {
            resolve(resp);
          } else {
            reject(resp);
          }
        }
      );
    });
}

export function fetchAccountInfo(
  consumerKey,
  consumerSecret,
  callback = undefined
) {
  return dispatch => {
    const handleAccountData = resp => {
      if (isApiSuccess(resp)) {
        dispatch(settingsSlice.actions.getAccountInfo(resp.data));
        if (typeof callback !== 'undefined') {
          callback(resp);
        }
      }
    };

    if (arClient.isOAuth2()) {
      arClient.getAccountData(handleAccountData);
    } else {
      arClient.getAccountData(handleAccountData);
    }
  };
}

export function logEvent(eventName, data) {
  userFlowTrackEvent(eventName, data);

  const formData = new URLSearchParams({
    uniqueId: store.getState().login.session.uniqueId,
    eventName,
    jsonData: JSON.stringify(data),
    appName: 'REACT',
  });

  fetch(LOG_EVENT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formData,
  }).catch(() => {
    // Silently fail for logging
  });
}

export const SOCIAL_MEDIA_TYPE = {
  Facebook: 'Facebook',
  Instagram: 'Instagram',
  TikTok: 'TikTok',
  YouTube: 'YouTube',
};

export const createSocialMediaConnection = (
  socialType,
  accountId,
  campaignId
) => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (isApiSuccess(resp)) {
        resolve(resp.data);
      } else {
        reject(new Error('Failed to create new social media connection'));
      }
    };
    arClient.doApiCall(
      '/adverity/create-connection',
      { socialType, accountId, campaignId },
      callback
    );
  });
};

export const createTikTokConnection = () => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (isApiSuccess(resp)) {
        resolve(resp.data);
      } else {
        reject(new Error('Failed to create TikTok media connection'));
      }
    };
    arClient.doApiCall('/tiktok/holder-authorization-url', {}, callback);
  });
};

export const createSparkAdsTikTokConnection = () => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (isApiSuccess(resp)) {
        resolve(resp.data);
      } else {
        reject(new Error('Failed to create TikTok media connection'));
      }
    };
    arClient.doApiCall('/tiktok/ads-authorization', {}, callback);
  });
};

export const getAdvertiserID = authCode => {
  return dispatch =>
    new Promise((resolve, reject) => {
      const callback = resp => {
        if (isApiSuccess(resp)) {
          dispatch(setAdvertiserIDList(resp.data));
          resolve(resp.data);
        } else {
          reject(new Error('Failed to get TikTok spark ads'));
        }
        dispatch(setAdvertiserSparkLoading(false));
      };
      dispatch(setAdvertiserSparkLoading(true));
      arClient.doApiCall('/tiktok/ads-authenticate', { authCode }, callback);
    });
};

export const storeTikTokConnection = (authCode, campaignId) => {
  return new Promise(resolve => {
    const callback = resp => {
      if (isApiSuccess(resp)) {
        resolve(resp.data);
      }
    };
    arClient.doApiCall(
      '/tiktok/holder-authentication',
      { authCode, campaignId },
      callback
    );
  });
};

export function removeSocialMediaConnection() {}

export function removeSocialMediaAccount(accountConnectionId, billingObjectId) {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (isApiSuccess(resp)) {
        resolve(true);
      } else {
        reject(new Error('Failed to remove account.'));
      }
    };
    arClient.doApiCall(
      '/adverity/change-billing-status',
      { accountConnectionId, billingObjectId, changeStatus: 'inactive' },
      callback
    );
  });
}

export const getDocusignAuthorization = () => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (isApiSuccess(resp)) {
        const url = resp.data?.data?.authorization_url || resp.data?.authorization_url || resp.data?.data || resp.data;
        resolve(typeof url === 'string' ? url : '');
      } else {
        reject(new Error('Failed to create new docusign media connection'));
      }
    };
    arClient.doApiCall('/docusign/authorization', {}, callback);
  });
};

export const storeDocusignConnection = (authCode, campaignId) => {
  return new Promise(resolve => {
    const callback = resp => {
      if (isApiSuccess(resp)) {
        resolve(resp.data);
      }
    };
    arClient.doApiCall(
      '/docusign/authentication',
      { authCode, campaignId },
      callback
    );
  });
};

export const removeDocusignConnection = campaignId => {
  return new Promise(resolve => {
    const callback = resp => {
      if (isApiSuccess(resp)) {
        resolve(resp);
      }
    };
    arClient.doApiCall('/docusign/remove-connection', { campaignId }, callback);
  });
};

/**
 * Get the Google OAuth redirect origin for the current environment.
 * Custom TLDs (.loc, .local, .test) rewrite to localhost for OAuth providers.
 */
const getGoogleOAuthRedirectOrigin = () => {
  const { hostname, port, protocol } = window.location;
  if (
    hostname.endsWith('.loc') ||
    hostname.endsWith('.local') ||
    hostname.endsWith('.test') ||
    hostname === '127.0.0.1'
  ) {
    return `${protocol}//localhost${port ? `:${port}` : ''}`;
  }
  return window.location.origin;
};

export const getGoogleDocsAuthorization = () => {
  const redirectURI = getGoogleOAuthRedirectOrigin();

  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (isApiSuccess(resp)) {
        resolve(resp.data);
      } else {
        reject(new Error('Failed to create new google docs media connection'));
      }
    };
    arClient.doApiCall('/google-doc/authorization', { redirectURI }, callback);
  });
};

export const storeGoogleDocsConnection = (authCode, campaignId) => {
  const redirectURI = getGoogleOAuthRedirectOrigin();

  return new Promise(resolve => {
    const callback = resp => {
      if (isApiSuccess(resp)) {
        resolve(resp.data);
      }
    };
    arClient.doApiCall(
      '/google-doc/authentication',
      { authCode, campaignId, redirectURI },
      callback
    );
  });
};

export const removeGoogleDocsConnection = (accountId, campaignId) => {
  return new Promise(resolve => {
    const callback = resp => {
      if (isApiSuccess(resp)) {
        resolve(resp);
      }
    };
    arClient.doApiCall(
      '/google-doc/remove-connection',
      { accountId, campaignId },
      callback
    );
  });
};

// No-op function kept for backward compatibility
export function setInitialPage() {}

export const {
  resetSettings,
  storePreviousPage,
  getAccountInfo,
  getAccountQuota,
  clearQuotaExceededInfo,
  toggleFetchingSubAccount,
  subAccountData,
  updateDictionaryWordList,
  updateIgnoreWordList,
  updateComplianceWordList,
  spliceWordFromList,
  updateWordsToAdd,
  requestMailChimpCheck,
  requestMarketoCheck,
  marketoFetFolders,
  marketoFoldersFetching,
  marketoCheckSuccess,
  marketoCheckFailed,
  requestAdwordsCheck,
  adwordsCheckSuccess,
  adwordsCheckFailed,
  mailChimpCheckSuccess,
  mailChimpCheckFailed,
  requestHubspotCheck,
  hubspotCheckSuccess,
  hubspotCheckFailed,
  requestContentByUrl,
  createdContentByUrl,
  requestWordPressCheck,
  wordPressCheckSuccess,
  wordPressCheckFailed,
  failedContentByUrl,
  getContentSources,
  getSearchConsoleProperties,
  fetchGaProfilesData,
  requestAddArticle,
  addArticleSuccess,
  addArticleFailed,
  updateHubspotBlogList,
  fetchingAdData,
  doneLoadingAdData,
  updateSocialMediaConnLoadingStatus,
  updateSocialMediaConn,
} = settingsSlice.actions;

export default settingsSlice.reducer;
